import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';

import { EtatOuvrage } from './etat-ouvrage.entity';
import { ArretSlbTLR } from '../../arret-slb/entities/arret-slb-tlr.entity';
import { NotifiableByMailOrder } from './has-id.interface';

export class ErrorAccesOrder implements NotifiableByMailOrder {
	forceMailsAsTest?: boolean;
	
	constructor(
		public accesId: number,
		public dateFin: LocalDateTime,
		public commentaireFermeture: string,
	) {
	}
}